import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";

interface IGetDataProps {
  token?: string;
  decision?: string;
}

const saveTalentFeedback = async (
  props: IGetDataProps,
): Promise<string> => {

  const url = `${END_POINT.BASE_URL}/job/feedback/talent?token=${props.token}&decision=${props.decision}`;

  const res = await axios.get(url, {
    headers: {
      Accept: "text/html",
    },
  });

  return res.data; // HTML string
};

export const useSaveTalentFeedback = (props: IGetDataProps) => {

  return useQuery(
    ["talent-feedback", props.token, props.decision],
    () => saveTalentFeedback(props),
    {
      enabled: !!props.token && !!props.decision,
      retry: false, // don't retry invalid/expired tokens
      refetchOnWindowFocus: false, // avoid duplicate confirmation
    },
  );
};
